/**
 * 跳转配置的"空行"工厂，配合 components/jumpConfig.vue 使用。
 *
 * 为什么单独一个 .js 而不是从 jumpConfig.vue 里 export：
 * package.json 里 devDependencies 写的是 vue-loader ^13（13 不会把 SFC 的具名导出
 * 透出来），实际打包又走 @vue/cli-service 4.5 内置的 vue-loader 15（会透出来）。
 * 两种行为差一个 import 就整页白屏，不值得赌，所以放普通模块里。
 *
 * ⚠ 键名与后端 activity_page_image / banner **同名同义**，含历史拼写
 *   `catetory_uuid` —— 就是为了让一行能直接喂给小程序的 $redirectBanner，
 *   零适配。别"顺手修正"成 category_uuid。
 *
 * ⚠ 所有键必须一开始就在：Vue 2 对后加的属性不做响应式，少一个键，那个字段
 *   在跳转配置面板里就是"改了不刷新"。
 */
export function emptyRow() {
  return {
    name: null,
    url_type: null,
    url: null,
    text: null,
    movie: null,
    mini_appid: null,
    mini_page: null,
    goods_uuid: null,
    item_uuid: null,
    miaosha_uuid: null,
    information_uuid: null,
    catetory_uuid: null,
    activity_page_uuid: null,
    // 只用于后台回显选了哪个商品/资讯/活动页。后端 saveComponents 走白名单，
    // 提交上去会被丢掉，不会入库。
    jump_target_name: null
  }
}
